// Copyright (c) 2017 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import actions from '../actions-list';
import {getCustomerByCkcId} from '../../../shared/repositories';
import {updateCustomerEditModalVisibility} from './customer-edit-modal-visibility';
import {updateCustomerSearchModalVisibility} from './customer-search-modal-visibility';

export const readCustomer = ckcId =>

    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            const customer = await getCustomerByCkcId(ckcId);

            dispatch({
                customer,
                type: actions.UPDATE_PRODUCTS_BY_CUSTOMER_SEARCH_CUSTOMER
            });

        } catch (error) {

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

            updateCustomerSearchModalVisibility(false)(dispatch);
            updateCustomerEditModalVisibility(false)(dispatch);

        }

    };



// WEBPACK FOOTER //
// ./src/product/products-by-customer/action-creators/read-customer.js